import Vue from 'vue/dist/vue.esm.js'
import Select2Mixin from '../mixins/select2_mixin.js.coffee'
AssociatedReportDocumentRow = {
  template: JST['procurement_documents/associated_report_document_row']()
  props: [
    'repDocsCollection',
    'associatedRepDoc',
    'asociatedRepDocsOpen'
  ]
  data: ->
    selected: ''
    authenticity_token: $('meta[name="csrf-token"]').attr('content')

  watch:
    selected: (newValue, oldValue) ->
      @$emit('update-asociated-rep-docs', newValue, oldValue)

  computed:
    associatedRepDocLink: ->
      "/report_documents/#{@associatedRepDoc.id}/edit"

  components:
    associatedReportDocumentSelect: Select2Mixin

  methods:
    deleteSelected: (e) ->
      e.preventDefault()
      @$el.style.display = 'none'
      @$emit('update-asociated-rep-docs', '', @selected)

    deleteExisting: (e) ->
      e.preventDefault()
      @$el.style.display = 'none'
      @$emit('update-asociated-rep-docs', '', @associatedRepDoc.id.toString())
}

KCVS.Views.ItemView = Vue.extend(
  template: JST['procurement_documents/document_row']()
  props: ['reportDocuments', 'document', 'procurementId', 'canEdit', 'isAdmin']

  data: ->
    docTypeOpen: false
    descriptionOpen: false
    asociatedRepDocsOpen: false
    destroying: false
    initialAssociatedRepDocs: []
    updatedRepDocs: []

  components:
    associatedReportDocumentRow: AssociatedReportDocumentRow

  beforeMount: ->
    initial_set = @document.report_documents
    if initial_set.length > 0
      @initialAssociatedRepDocs = initial_set
      @updatedRepDocs = initial_set

  mounted: ->
    row = @$el
    row.animate({
        backgroundColor: ['#ffffff', '#bfdf9f']
      }, 1000 )
    setTimeout ->
      row.animate({
        backgroundColor: ['#bfdf9f', '#ffffff']
      }, 4000 )
    , 1000

  computed:
    emptyDocument: ->
      {display_name: '', id: ''}
    associatedDocumentIds: ->
      @initialAssociatedRepDocs.map( (doc) -> doc.id)
    repDocsCollection: ->
      arr = @reportDocuments.map(
        (opt) -> [opt.display_name, opt.id]
      )
      arr.filter(
          (doc) =>
            !@associatedDocumentIds.includes(doc[1])
        )

  methods:
    addAssociatedDocument: (e)->
      e.preventDefault()
      @initialAssociatedRepDocs.push(@emptyDocument)

    removeDocument: (e) ->
      e.preventDefault()
      return if @destroying # don't run request twice if button is quickly pressed more than once
      if confirm I18n.t('delete_confirmation')
        @destroying = true

        $.ajax
          dataType: 'JSON',
          url: "/procurements/#{@procurementId}/documents/#{@document.id}",
          data: {authenticity_token: @authenticity_token},
          method: 'DELETE',
          success: (_, response) =>
            $('#msg-board').show().html(_.notice).removeClass("alert-danger").addClass("alert alert-success")
            $('#msg-board').fadeOut(4000)
            @.$emit('fetch-procurement-documents')
            @destroying = false
          error: ->
            $('#msg-board').show().html(I18n.t('javascript.unable_to_delete_document')).removeClass("alert-success").addClass("alert alert-danger")
            @destroying = false

    updateDocument: () ->
      $.ajax
        dataType: 'JSON',
        url: "/procurements/#{@procurementId}/documents/#{@document.id}",
        data: {authenticity_token: @authenticity_token},
        method: 'PATCH',
        data:
          procurement_document: @document
        success: (_, response) =>
          $('#msg-board').show().html(I18n.t('javascript.document_updated')).removeClass("alert-danger").addClass("alert alert-success")
          $('#msg-board').fadeOut(4000)
          @.$emit('fetch-procurement-documents')
        error: ->
          $('#msg-board').show().html(I18n.t('javascript.unable_to_update_document')).removeClass("alert-success").addClass("alert alert-danger")

    openDocTypeInput: (e) ->
      e.preventDefault()
      @docTypeOpen = true
      @.$nextTick ->
        $(".#{@document.id}-doc-type-input").focus()

    openDescriptionInput: (e) ->
      e.preventDefault()
      @descriptionOpen = true
      @.$nextTick ->
        $(".#{@document.id}-description-input").focus()

    openAsociatedDocumentsInput: (e) ->
      e.preventDefault()
      @asociatedRepDocsOpen = true
      @.$nextTick ->
        $(".#{@document.id}-asoc-doc-input").focus()

    saveDocumentType: (e) ->
      if e
        e.preventDefault()
      @updateDocument()
      @docTypeOpen = false

    saveDescription: (e) ->
      if e
        e.preventDefault()
      @updateDocument()
      @descriptionOpen = false

    updateAsociatedRepDocs: (newValue, oldValue) ->
      @updatedRepDocs = @updatedRepDocs.filter((doc) =>
        if doc.id
          doc.id.toString() != oldValue
      )
      if newValue && newValue.length
        obj = @repDocsCollection.find( (doc) =>
          doc[1].toString() == newValue
        )
        @updatedRepDocs.push({ display_name: obj[0], id: obj[1] })

    saveAssociatedRepDocs: ->
      @initialAssociatedRepDocs = @updatedRepDocs.reduce((acc, doc) =>
          if doc.id.toString() != "" && !acc.some((existingDoc) -> existingDoc.id == doc.id)
            acc.push(doc)
          acc
        , []
      )
      $.ajax
        dataType: 'JSON',
        url: "/procurements/#{@procurementId}/documents/#{@document.id}/update_report_documents"
        method: 'POST',
        data:
          associated_report_document_ids: @associatedDocumentIds,
          authenticity_token: @authenticity_token
        success: (_, response) =>
          @asociatedRepDocsOpen = false
          $('#msg-board').show().html(_.notice).removeClass("alert-danger").addClass("alert alert-success")
          $('#msg-board').fadeOut(4000)
          @.$emit('fetch-procurement-documents')
          $(".select2-container").hide()
          $(".associated-report-document-select").hide()
          $(".associated-report-document-row").show()
        error: ->
          $('#msg-board').show().html(I18n.t('javascript.unable_to_update_procurement_report_documents')).removeClass("alert-success").addClass("alert alert-danger")

    submitWithEnter: (button, e) ->
      e.preventDefault()
      if e.keyCode == 13
        switch button
          when "document-type" then @saveDocumentType()
          when "description" then @saveDescription()
          else return
)
